<template>
    <b-col cols='12' sm='6' md='4' lg='3' xl='2' class='mt-2'>
      <b-card draggable>
        <b-form-row slot="header" id="head">
          <b-col>{{asset.name}} ({{asset.symbol}}) 
            <b-btn :hidden="this.base()" @click="closeTicker" type="button" class="close">
          &#x2573;</b-btn></b-col>
        </b-form-row>
          
         <b-form-row class="">
            <b-col cols='6' sm='12' md='12' lg='12' class="text-center"> 
                <div id="assetPriceBase">${{(asset.data.price * baseCurrency()).toFixed(2)}}</div>
                <div id="assetPercentBase">{{totalPercentage()}}%</div>  
                <div id="assetPrice">{{asset.data.price}}<span class="resolveToSymbol"> ({{asset.resolveTo}})</span></div>
                <div id="assetPercent">{{(asset.data.percent).toFixed(3)}}%</div>
            </b-col>
           
            <b-col cols='6' sm='12' md='12' lg='12' class="text-center totals">
                <div id="assetTotalBase">${{(asset.total * this.baseCurr.data.price).toFixed(2) }}</div>
                <div id="assetTotal">{{(asset.total).toFixed(7)}}<span class="resolveToSymbol"> (BTC)</span></div>     
            </b-col> 
          </b-form-row>  
      </b-card>    
    </b-col>  
</template>

<script>

// import Chart from 'chart.js'

export default {
  props: {
    index: '',
    asset: {
      default: {
        name: '',
        symbol: '',
        exchange: '',
        data: {
          symbol: '',
          price: 0,
          percent: 0
        },
        base: false,
        total: 0,
        amount: 0
      }
    },
    baseCurr: {
      default: {
        data: {
          symbol: 'BTC',
          price: 0,
          percent: 0
        },
        total: 0,
        amount: 0
      }
    }
  },
  data: function () {
    return {
      status: 'updated',
      chartdata: {
        type: 'bar',
        data: {
          labels: [ 'lo', 'curr', 'hi' ],
          datasets: [{
            data: [],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 159, 64, 0.2)'
            ]
          }]
        },
        options: {
          responsive: true,
          lineTension: 1,
          tooltips: {
            caretPadding: 4,
            titleFontSize: 20,
            bodyFontSize: 15,
            backgroundColor: 'rgba(73,73,73,0.5)',
            displayColors: false,
            mode: 'x',
            intersect: false
          },
          hover: {
            mode: 'index',
            intersect: false
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              display: true,
              gridLines: {display: false},
              ticks: {
                beginAtZero: false,
                padding: 0
              }
            }],
            xAxes: [{
              display: true,
              gridLines: {display: false}
            }]
          }
        }
      }
    }
  },
  computed: {
    title () {
      return this.asset.name
    }
  },
  created () {},
  methods: {
    baseCurrency: function () {
      if (this.baseCurr.data.price === this.asset.data.price) {
        return 1
      } else {
        return this.baseCurr.data.price
      }
    },
    base: function () {
      if (this.baseCurr.data.price === this.asset.data.price) {
        return true
      } else {
        return false
      }
    },
    totalPercentage: function () {
      let assetDecimal = (100 + this.asset.data.percent) / 100
      let baseDecimal = (100 + this.baseCurr.data.percent) / 100
      if (this.baseCurr.data.price === this.asset.data.price) {
        return this.asset.data.percent.toFixed(3)
      } else {
        let answer = 100 * ((assetDecimal * baseDecimal) - 1)
        // answer = assetDecimal
        return answer.toFixed(3)
      }
    },
    closeTicker: function () {
      console.log('emit event to close ticker', this.index)
      this.$emit('close-ticker', this.index)
    }
  },
  mounted () {
    // const ctx = document.getElementById(this.title)
    // this.myChart = new Chart(ctx, this.chartdata)
    // console.log('initial:', this.chartdata.data)
  }
}
</script>

<style scoped>
#head{
  padding-left: 1px;
  font-size: 100%;
}
.card-header{
  background-color:rgba(255, 192, 7, 1);
  font-family: 'Lato';
  word-break: break-word;
  font-size: 70%;
  color: white;
  padding: 3px;
  height: 25px;
}
#assetPriceBase{
  font-family: 'Lato';
  font-size: 125%;
  line-height: 1.2;
  padding: 0px;
}
#assetPercentBase{
  font-family: 'Lato';
  font-size: 60%;
}
#assetPrice{
  font-family: 'Lato';
  font-size: 80%;
}
.resolveToSymbol{
  font-family: 'Lato';
  font-size: 30%;
}
#assetPercent{
  font-family: 'Lato';
  font-size: 60%;
}
#assetTotalBase{
  font-family: 'Lato';
  font-size: 125%;
  line-height: 1;
  
}
#assetTotal{
  font-family: 'Lato';
  font-size: 80%;
  line-height: 1.5;
}

button{
  font-size: 0.9rem;
  padding: 2px;
  color: white;
}
.exchange{
  text-align: center;
  font-size: .7rem;
  color: grey;
}
.price{
  text-align: center;
  font-size: .8rem; 
}
.totals{
  padding-top: 5px;
  color: white;
  background: grey;
}
.close{
  color: white;
  background: none;
  font-size: 0.5rem;
  border: none;
  text-shadow: none;
  z-index: 1;
  opacity: 1;
}
.card-body{
  padding-top: 1px; 
  padding-left: 0.4rem; 
  padding-right: 0.4rem;
  padding-bottom: 1px;
} 
.input-group-prepend{
  width:300px;
}
</style>




// WEBPACK FOOTER //
// src/components/btr-ticker.vue